import React from 'react';
import { newsData } from '../data/mockData';

function News() {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-green-800">ข่าวสาร</h2>
        <a href="#" className="text-sm text-gray-600 hover:text-green-800">ดูทั้งหมด</a>
      </div>
      <div className="space-y-4">
        {newsData.map((news) => (
          <div key={news.id} className="flex items-start space-x-3 border-b pb-3">
            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-green-800">📰</span>
            </div>
            <div className="flex-1">
              <a href="#" className="text-gray-800 hover:text-green-800">
                {news.title}
                {news.isNew && (
                  <span className="ml-2 text-red-500 text-sm">New</span>
                )}
              </a>
              <div className="text-sm text-gray-500 mt-1">
                อัพเดทเมื่อ {news.date} {news.time}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default News; 